import { isDevToolsEnabled } from './isDevToolsEnabled';

/**
 * Execute a diagnostics task in a non-blocking way if
 * the feature flag is enabled
 * @param task Task to execute
 * @param sync Execute the task immediately and not schedule it for the next frame
 */
export const executeDiagnosticsTask = (task: () => void, sync: boolean = false) => {
    if (isDevToolsEnabled()) {
        sync ? task() : requestAnimationFrame(task);
    }
};
